import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface RegtankOnboardingRequest {
  token: string;
  requestIds: string[];
}
const getRegtankOnboardingDetail = async ({
  token,
  requestIds,
}: RegtankOnboardingRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/regtank-get-onboarding-detail`,
      {
        params: { requestIds: requestIds },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default getRegtankOnboardingDetail;
